import Base_URL from '../config/apiConfig';
import axiosInstance from './axiosInstance';

const METADATA_URL = `${Base_URL}/metadata`;

// GET /metadata/modules/:source
export const fetchModulesBySource = async (source) => {
  try {
    const response = await axiosInstance.get(
      `${METADATA_URL}/modules/${source}`,
    );
    return Array.isArray(response.data.modules) ? response.data.modules : [];
  } catch (error) {
    console.error('Failed to fetch modules:', error);
    return [];
  }
};

// POST /resolve-entities
export const resolveEntitiesService = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${METADATA_URL}/resolve-entities`,
      payload,
    );
    console.log('resolveEntitiesService - raw response:', res?.data);

    let entities = [];
    if (Array.isArray(res.data?.entities)) {
      entities = res.data.entities;
    } else if (Array.isArray(res.data?.entities?.entities)) {
      entities = res.data.entities.entities;
    } else if (Array.isArray(res.data)) {
      // fallback if backend returns array directly
      entities = res.data;
    }
    console.log('resolveEntitiesService - parsed entities:', entities);
    return entities;
  } catch (error) {
    console.error('Entity resolve error:', error);
    throw error;
  }
}
// POST /refresh-entities
export const refreshEntitiesService = async (payload) => {
  try {
    const res = await axiosInstance.post(
      `${METADATA_URL}/refresh-entities`,
      payload,
    );
    console.log('refresh res:', res);

    const sourceEntities = Array.isArray(res.data.sourceEntities)
      ? res.data.sourceEntities
      : [];

    const destinationEntities = Array.isArray(res.data.destinationEntities)
      ? res.data.destinationEntities
      : [];

    console.log('sourceEntities:', sourceEntities);
    console.log('destinationEntities:', destinationEntities);

    return { sourceEntities, destinationEntities };
  } catch (error) {
    console.error('Entity refresh error:', error);
    return { sourceEntities: [], destinationEntities: [] }; // safe fallback
  }
};

/**
 * Resolves fields for given workflow configuration.
 * @param {Object} payload - Payload with label and configs
 * @returns {Array} resolved fields (always returns an array)
 */
export const resolveFieldsService = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${METADATA_URL}/resolve-fields`,
      payload,
    );
    console.log('Resolved Fields Response:', response.data);

    const fields = Array.isArray(response.data.fields)
      ? response.data.fields
      : [];

    return fields;
  } catch (err) {
    console.error('Failed to resolve fields:', err);
    // Re-throw timeout errors so they can be handled properly
    if (
      err.isTimeout ||
      err.code === 'ECONNABORTED' ||
      err.message?.includes('timeout')
    ) {
      throw err;
    }
    return [];
  }
};

export const getSavedMappingAPI = async (workflowId) => {
  try {
    const response = await axiosInstance.get(
      `${Base_URL}/Get-Mapping/${workflowId}`,
    );
    return {
      workflowId: response.data.workflow_id,
      data: response.data.mapping_json || {},
    };
  } catch (err) {
    console.error('Failed to get saved mapping:', err);
    throw err;
  }
};
